<div fxLayout="column" fxLayoutAlign="center start">
    <p>
        <span *ngIf="product.supplierPrice">
            <span *ngIf="HideSupplierPrice" style="visibility: hidden;">
                ---
            </span>
            <span *ngIf="!HideSupplierPrice">
                {{'TOBA LIGHT.label.shekel' | translate }}{{product.supplierPrice | number : '1.2-2'}}
            </span>
        </span>
    </p>
    <p style="cursor: pointer;" (touchstart)="mouseup()" (touchend)="mousedown()" (mousedown)="mouseup()" (mouseup)="mousedown()" *ngIf="product.clientPrice && priceViewService.viewPrice" class="new-price prevent-select">{{'TOBA LIGHT.label.shekel' | translate }}{{product?.clientPrice | number : '1.2-2'}}</p>
</div>

